export const feedbackUrl = 'https://gh.io/models-feedback'
export const bookACallUrl = 'https://gh.io/models-playground-feedback'
export const productTermsLink = 'https://www.microsoft.com/licensing/terms/productoffering/MicrosoftAzure/MCA'
export const privacyStatementLink = 'https://www.microsoft.com/licensing/terms/product/PrivacyandSecurityTerms/MCA'
export const modelsTabChangelogLink =
  'https://github.blog/changelog/2025-05-19-github-models-built-into-your-repository-is-in-public-preview/'
export const actionsDocsLink =
  'https://docs.github.com/github-models/use-github-models/integrating-ai-models-into-your-development-workflow#using-ai-models-with-github-actions'
export const apiDocsLink = 'https://docs.github.com/rest/models?apiVersion=2022-11-28'
export const modelsDocs = 'https://docs.github.com/github-models/about-github-models'
export const rateLimitsLink = 'https://gh.io/models-rate-limits'
